import React from 'react';
import { useWidgetPlugin } from './useWidgetPlugin';
import { useSlotHighlighting } from './useSlotHighlighting';
import { useSlotUniqueId } from './useSlotUniqueId';
import { PlaceholderWrapper } from '../components/PlaceholderWrapper';
import { buildSlotPlaceholderDataHook } from '../utils/buildUniqueSlotId';
export const useSlotPlaceholder = (slotId) => {
    const { PluginComponent, isEmpty } = useWidgetPlugin(slotId);
    const isHighlighted = useSlotHighlighting(slotId);
    const slotUniqueId = useSlotUniqueId(slotId);
    const Placeholder = React.useCallback(() => (React.createElement(PlaceholderWrapper, { slotUniqueId: slotUniqueId, isHighlighted: isHighlighted, isEmpty: isEmpty, dataHook: buildSlotPlaceholderDataHook(slotUniqueId), PluginComponent: PluginComponent })), [slotUniqueId, isHighlighted, isEmpty, PluginComponent]);
    return [Placeholder, isEmpty];
};
//# sourceMappingURL=useSlotPlaceholder.js.map